import { c as _c } from "react/compiler-runtime";
import { InterfaceChainUtils } from '@morpho-org/dapp-core';
import { MarketIdentity } from '@morpho-org/ui-v6/client';
import { UNKNOWN_SYMBOL } from '@morpho-org/ui-v6/utils';
import { memo } from 'react';
import type { VaultV2PendingTimelockDecodedData } from '@/components/VaultPage/VaultV2/types/pendingTimelocks';
import { InternalLink } from '@/components/common/InternalLink';
import { getMarketUrl } from '@/helpers/routing';
import { HoverableWrapper } from '../VaultV2PendingTimelockStyled';
type MarketV1CapData = Extract<Extract<VaultV2PendingTimelockDecodedData, {
  __typename: 'VaultV2IncreaseCapPendingData';
}>['config']['data'], {
  __typename: 'MarketV1CapData';
}>;
type Market = NonNullable<MarketV1CapData['market']>;
interface MarketItemLinkProps {
  market: Market | null | undefined;
}
const MarketItemLink = t0 => {
  const $ = _c(14);
  const {
    market
  } = t0;
  if (!market) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="gap-xs flex items-center"><span className="text-2xs text-foreground">-</span></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const {
    collateralAsset,
    loanAsset,
    marketId
  } = market;
  const chainId = loanAsset.chain.id;
  let T0;
  let t1;
  if ($[1] !== chainId || $[2] !== collateralAsset?.symbol || $[3] !== loanAsset.symbol || $[4] !== marketId) {
    const identifier = InterfaceChainUtils.getIdentifierById(chainId);
    const collateralSymbol = collateralAsset?.symbol ?? UNKNOWN_SYMBOL;
    const loanSymbol = loanAsset.symbol;
    T0 = InternalLink;
    t1 = getMarketUrl({
      identifier,
      marketId,
      collateralSymbol,
      loanSymbol
    });
    $[1] = chainId;
    $[2] = collateralAsset?.symbol;
    $[3] = loanAsset.symbol;
    $[4] = marketId;
    $[5] = T0;
    $[6] = t1;
  } else {
    T0 = $[5];
    t1 = $[6];
  }
  const t2 = collateralAsset ?? undefined;
  let t3;
  if ($[7] !== loanAsset || $[8] !== t2) {
    t3 = <HoverableWrapper><MarketIdentity loanAsset={loanAsset} collateralAsset={t2} /></HoverableWrapper>;
    $[7] = loanAsset;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== T0 || $[11] !== t1 || $[12] !== t3) {
    t4 = <T0 href={t1} onClick={_temp}>{t3}</T0>;
    $[10] = T0;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export default memo(MarketItemLink);
function _temp(e) {
  return e.stopPropagation();
}